import { UIIcon } from '../../../config/icons';
import { $el } from '../elements';
import { UIClassesSpec, UITabsKind } from '../types';
import { UIViewSpec, UIView } from '../view';
import { UIButton } from './button';
import { UIInkBar } from './inkbar';

export interface UITab {
    title: string;
    view: () => UIViewSpec;
    classes?: UIClassesSpec;
    when?: (() => boolean) | boolean;
}

export interface UITabsOptions {
    kind?: UITabsKind;
    initial?: number;
    classes?: UIClassesSpec;
    tabs_classes?: UIClassesSpec;
    tabs_placeholder?: boolean;
    extra_buttons?: UIViewSpec;
    back_button_action?: () => void;
}

export class UITabs extends UIView {
    private _current?: number;
    private _page!: HTMLElement;
    private _tabs: UITab[];
    private _buttons: UIButton[];
    private _inkbar: UIInkBar;

    constructor(tabs: UITab[], options: UITabsOptions = {}) {
        super('div', ['ui-tabs', options.classes, options.kind || 'k-default']);
        this._tabs = tabs;

        const tab_buttons = $el.DIV(['r-tabs', options.tabs_classes], [
            this._buttons = tabs.map((tab, i) => {
                const b = new UIButton({ title: tab.title, kind: 'k-text', classes: tab.classes, on_click: () => { this.setCurrent(i) } })
                if(tab.when === false || (typeof tab.when === 'function' && !tab.when()))
                    b.ui_hide();
                return b;
            }),
            this._inkbar = new UIInkBar
        ]);

        if(options.extra_buttons) {
            const extra = options.extra_buttons;
            extra.classList.add('r-extra');
            tab_buttons.ui_add(extra);
        }

        if(options.back_button_action) {
            const back_button = new UIButton({ icon: UIIcon.ARROW_LEFT, kind: 'k-text', on_click: options.back_button_action });
            tab_buttons.ui_add($el.DIV('r-back-button', back_button));
        }

        this.ui_add([
            tab_buttons,
            options.tabs_placeholder && $el.DIV(['r-tabs-placeholder']),
            options.tabs_placeholder && $el.DIV(['r-tabs-bg'])
        ]);

        this.setCurrent(options.initial || 0);
    }

    reloadWhen() {
        for(let i = 0; i < this._tabs.length; i++) {
            const w = this._tabs[i].when;
            if(w === false || (typeof w === 'function' && !w()))
                this._buttons[i].ui_hide();
            else
                this._buttons[i].ui_show();
        }
    }

    reloadCurrent() {
        const current = this._current;
        if(current == undefined) return;
        const new_page = $el.DIV('r-page', this._tabs[current].view());
        this._page.remove();
        this.ui_add(new_page);
        this._page = new_page;
    }

    setCurrent(current: number) {
        if(current === this._current) return;
        if(current < 0 || current > this._tabs.length - 1) return;

        const new_page = $el.DIV('r-page', this._tabs[current].view());
        this.ui_add(new_page);

        if(this._current != undefined) {
            this._buttons[this._current].classList.remove('f-active');
            this._page.remove();
        }

        this._buttons[current].classList.add('f-active');
        this._page = new_page;
        this._current = current;

        this._updateInkbar();
    }

    private _updateInkbar() {
        if(this._current == undefined) return;
        this._inkbar.update(this._buttons[this._current]);
    }
}
